<template>
  <v-container fluid>
    <h3 class="primary--text text-xs-left mt-4 mb-4">Healthcare Provider</h3>
    <div class="text-xs-left">
      <p>
        I have read and understand the requirements of the Wyoming State Loan Repayment Program,
        and affirm that I meet the qualifications for participation in the Wyoming State Loan Repayment Program.
      </p>
      <p>
        I certify that the information provided is accurate and complete to the best of my knowledge and that I am applying for Wyoming State Loan Repayment of loans
        incurred solely for the costs of education, including reasonable living expenses, leading to a degree in an eligible healthcare profession
      </p>
      <p>
        I hereby authorize the Wyoming Department of Health, Public Health Division,
        Office of Rural Health to contact the listed employer and relevant licensing authorities to confirm my eligibility for this program.
      </p>
      <p>As the healthcare provider applicant, by clicking "submit application, I certify all the above information is correct</p>
    </div>
    <v-layout row wrap v-for="s in submitter" :key="s.ID">
      <v-flex xs6 pr-4>
        <v-text-field       
          label="Signed By"
          :value="`${s.User.FirstName} ${s.User.LastName}`"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs6 pr-4>
        <v-text-field
          label="Signed On"
          :value="s.ChangedOn | formattedDate"
          readonly
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-btn color="secondary" @click="submit" v-if="!disabled">Submit Application</v-btn>
    </v-layout>
  </v-container>
</template>
<script>
import Rules from '../validation/rules'
import { authComputed } from '@state/helpers'
export default {
  
  name: 'Applications',
  props: {
    Status: Array,
    CurrentStatus: Object
  },
  data() {
    return {
      menu: false,
    }
  },
  methods: {
    submit(){
      this.$emit('submit')
    }
  },
  components: {

  },
  computed: {
    ...authComputed,
    submitter(){
      var items = []
      this.Status.forEach(status => {
        if(status.Status.Description == "Submitted"){
          items.push(status)
        }
      });
      return items
    },
    disabled(){
      return this.currentUser.Role.Description.toLowerCase() == 'sitefacilitator' || this.CurrentStatus === undefined || (this.CurrentStatus && this.CurrentStatus.Status && this.CurrentStatus.Status.Description != 'New')
    }
  },
  watch: {
    Status: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
}
</script>